import { SortDownIcon2, SortNormalIcon, SortUpIcon2 } from '@/shared/ui/assets';
import { DurationFormatter } from '@/shared/ui/components/formatters';
import Skeleton from 'react-loading-skeleton';
import { t } from 'ttag';

/**
 * Picks the sort indicator image for a table column header. Returns the up arrow for 'ascend', the down arrow for 'descend', and the neutral icon for any other state.
 *
 * @param sortOrder - Current sort direction of the column.
 * @returns An image element for the matching sort state.
 */
const renderSortIcon = (sortOrder: any) => {
  if (sortOrder === 'ascend') {
    return <img src={SortUpIcon2} alt="Sort Up Icon" />;
  }
  if (sortOrder === 'descend') {
    return <img src={SortDownIcon2} alt="Sort Up Icon" />;
  }
  return <img src={SortNormalIcon} alt="Sort Up Icon" />;
};

/**
 * Formats a monitored-duration table cell using the unit supplied through the column's extra data. Renders a skeleton until formatExtraData.isLoadedData is set, then a duration formatter for a non-empty cell or an N/A placeholder.
 *
 * @param cell - Raw duration value of the cell.
 * @param row - Row record the cell belongs to.
 * @param rowIndex - Index of the row in the table.
 * @param formatExtraData - Column extras carrying isLoadedData and the duration unit.
 * @returns The formatted duration, an N/A placeholder or a skeleton.
 */
const timeMonitorFormatter = (cell: any, row: any, rowIndex: any, formatExtraData: any) => {
  const { isLoadedData, unit } = formatExtraData;
  if (isLoadedData) {
    if (cell) {
      return <DurationFormatter {...({ duration: cell, unit } as any)} />;
    }
    return <div>{t`N/A`}</div>;
  }
  return <Skeleton count={1} />;
};

export { renderSortIcon, timeMonitorFormatter };
